function e() {
  return typeof window < "u";
}
function n() {
  return !e();
}
export {
  e as isBrowser,
  n as isServer
};
//# sourceMappingURL=index61.js.map
